import React from 'react'
import { Bar, ComposedChart, ResponsiveContainer, Tooltip } from 'recharts'

import { CartesianGrid } from '../../../components/chart/CartesianGrid'
import { XAxis } from '../../../components/chart/XAxis'
import { YAxis } from '../../../components/chart/YAxis'
import {
  EarningsColor,
  PRICE_REVISIONS_YAXIS_WIDTH,
  UPDOWN_REVISIONS_CHART_HEIGHT,
  UPDOWN_REVISIONS_TICK_COUNT,
} from '../constants'
import { RevisionsChartData } from '../types'
import { getEarningsColor } from '../utils'

function absIntFormat(value: number): string {
  return Math.abs(value).toFixed()
}

type Props = {
  activeIndex: number
  chartData: RevisionsChartData
  endingTimestamp: number
  isActive: boolean
  onSetActiveIndex: (value: number) => void
  onSetIsActive: (value: boolean) => void
  startingTimestamp: number
}

export function UpDownRevisionsChart({
  activeIndex,
  chartData,
  endingTimestamp,
  isActive,
  onSetActiveIndex,
  onSetIsActive,
  startingTimestamp,
}: Props) {
  return (
    <div>
      <div
        /**
         * Fix a problem with chart tooltip not hiding correctly on mouse leave
         * See: https://github.com/recharts/recharts/issues/2726
         */
        onMouseEnter={() => {
          onSetIsActive(true)
        }}
        onMouseLeave={() => {
          onSetIsActive(false)
        }}
      >
        <ResponsiveContainer height={UPDOWN_REVISIONS_CHART_HEIGHT}>
          <ComposedChart
            data={chartData}
            margin={{ left: 10 + PRICE_REVISIONS_YAXIS_WIDTH, right: 4, top: 0, bottom: 0 }}
            stackOffset="sign"
            syncId="estimateRevisions"
            onMouseMove={(props) => {
              if (typeof props.activeTooltipIndex === 'number' && props.activeTooltipIndex !== activeIndex) {
                onSetActiveIndex(props.activeTooltipIndex)
              }
            }}
            onMouseLeave={() => {
              onSetActiveIndex(-1)
            }}
          >
            <CartesianGrid className="first:[stroke-dasharray:0] last:[stroke-dasharray:0]" />
            <XAxis dataKey="timestamp" domain={[startingTimestamp, endingTimestamp]} hide scale="time" type="number" />
            <YAxis
              domain={['auto', 'auto']}
              orientation="right"
              tickCount={UPDOWN_REVISIONS_TICK_COUNT}
              tickFormatter={(value, idx) =>
                idx > 0 && idx < UPDOWN_REVISIONS_TICK_COUNT - 1 ? absIntFormat(value) : ''
              }
              type="number"
              width={PRICE_REVISIONS_YAXIS_WIDTH}
              interval={0}
            />
            <Bar
              dataKey="upRevisions"
              fill={getEarningsColor(EarningsColor.upBar)}
              isAnimationActive={false}
              maxBarSize={1}
              stackId="stack"
            ></Bar>
            <Bar
              dataKey="negDownRevisions"
              fill={getEarningsColor(EarningsColor.downBar)}
              isAnimationActive={false}
              maxBarSize={1}
              stackId="stack"
            ></Bar>
            <Tooltip
              content={() => null}
              cursor={isActive ? { stroke: getEarningsColor(EarningsColor.cursor) } : false}
              isAnimationActive={false}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
